import axios from '@/api'

export default {
  getAll() {
    return axios.get('/companies')
  },
  create(data) {
    return axios.post('/companies', data)
  },
  update(id, data) {
    return axios.put(`/companies/${id}`, data)
  },
  delete(id) {
    return axios.delete(`/companies/${id}`)
  },
  toggleStatus(id) {
    return axios.patch(`/companies/${id}/change-status`)
  }
}
